export default "__VITE_ASSET__j21WbIko__"